// extracted by mini-css-extract-plugin
export default {"productGrid":"B4-z","centerLink":"C4-z","productSection":"D4-z","item":"E4-z","ctaButton":"F4-z"};